import { useCallback, useMemo } from 'react'
import { arrayToMap } from 'lib/array/arrayUtils'
import type { TripItineraryData } from 'tripPlanner/api/types'
import type { SendMessageOptions } from 'tripPlanner/components/AddToTrip/useAddHotelToTrip'
import type { GeoPoint } from 'tripPlanner/types/placeAndDateTime'
import DrawerListingMapPreview, { type DrawerListingMapItem } from '../DrawerListingMapPreview'
import type { DrawerHotel } from './types'

interface Props {
  hotels: Array<DrawerHotel & { geoLocation: GeoPoint }>
  coordinates: GeoPoint
  onSelectHotel: (hotel: DrawerHotel) => void
  onViewOnMap?: () => void
  itineraryData?: TripItineraryData
  onSendMessage?: (message: string, options?: SendMessageOptions) => void
}

function HotelListingMapPreview({
  hotels,
  coordinates,
  onSelectHotel,
  onViewOnMap,
  itineraryData,
  onSendMessage,
}: Props) {
  const hotelsById = useMemo(() => arrayToMap(hotels, hotel => hotel.offerId), [hotels])
  const items = useMemo<Array<DrawerListingMapItem>>(() => hotels.map(hotel => ({
    id: hotel.offerId,
    name: hotel.name,
    coordinates: hotel.geoLocation,
    kind: 'hotel',
  })), [hotels])
  const handleSelectItem = useCallback((id: string) => {
    const hotel = hotelsById.get(id)
    if (hotel) onSelectHotel(hotel)
  }, [hotelsById, onSelectHotel])

  return (
    <DrawerListingMapPreview
      items={items}
      coordinates={coordinates}
      onSelectItem={handleSelectItem}
      onViewOnMap={onViewOnMap}
      itineraryData={itineraryData}
      onSendMessage={onSendMessage}
    />
  )
}

export default HotelListingMapPreview
